export default "__VITE_ASSET___nvYLAnt__"